import {CountryEnumIndices} from '@bdswiss/common-enums'

const countryList: Readonly<CountryEnumIndices[]> = [
  CountryEnumIndices.ng,
] as const

export function itHasToBeDisplayedForCountry(country: string) {
  return countryList.includes(country.toLowerCase() as CountryEnumIndices)
}
